import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.webp";
import "../App.css";
import { FiPhone } from "react-icons/fi";


import a from "../assets/hinge_icon.webp";
import b from "../assets/telescopic-channel.jpg";
import c from "../assets/drawer.png";
import d from "../assets/pull-out.webp";
import e from "../assets/basketicon.png";
import f from "../assets/corner-icon.webp";
import g from "../assets/basketicon.webp";
import h from "../assets/pvc-rolling-shutter.webp";
import i from "../assets/plain-pipe-basket.png";
import j from "../assets/pelmet.png";
import k from "../assets/folding-braket.webp";
import l from "../assets/dowel.webp";
import m from "../assets/skirting-silver.webp";
import n from "../assets/door-straightner.webp";
import o from "../assets/profile-icon.jpg";



const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);

  return (
    <>

    
      <header className="navbar-header">
        <div className="navbar-bar">
          {/* Logo */}
        
          <Link to="/"> <img src={logo} alt="Logo" className="navbar-logo" loading="lazy" /></Link>
      

          {/* ===== DESKTOP MENU ===== */}
          <ul className="navbar-menu desktop-menu">
            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/about">About</Link>
            </li>

            {/* ===== PRODUCTS ===== */}
            <li className="products-item">
            <span className="products-link">
  Our Products 
  <svg className="icon" width="16" height="10" viewBox="0 0 24 24">
    <path
      d="M6 9L12 15L18 9"
      stroke="black"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
</span>

              <div className="mega-menu">
                <div className="mega-grid">
                  <Link to="/cabinet-hinges" className="mega-link">
                    <img src={a} alt="cabinet hinge soft close stainless steel kitchen hinge Slimline Hardware"loading="lazy"  />
                    <span>Hinge</span>
                  </Link>

                  <Link to="/telescopic-channel" className="mega-link">
                    <img src={b} alt="telescopic drawer channel heavy duty smooth sliding kitchen drawer rail" loading="lazy" />
                    <span>Telescopic Channel</span>
                  </Link>

                  

                  <Link to="/corner-solutions" className="mega-link">
                    <img src={f} alt="kitchen corner solutions carousel magic corner cabinet organizer" loading="lazy" />
                    <span>Corner Solutions</span>
                  </Link>

                  <Link to="/slim-box" className="mega-link">
                    <img src={c} alt="slim box drawer system modern kitchen drawer storage soft close slim box" loading="lazy" />
                    <span>Slim Box</span>
                  </Link>

                  <Link to="/pull-out" className="mega-link">
                    <img src={d} alt="kitchen pullout basket stainless steel pull out drawer organizer"loading="lazy"  />
                    <span>Pullouts</span>
                  </Link>

                  <Link to="/multiuseBasket" className="mega-link">
                    <img src={g} alt="multi use kitchen basket storage organizer stainless steel basket" loading="lazy" />
                    <span>Multi Use Basket</span>
                  </Link>

                  <Link to="/basket" className="mega-link">
                    <img src={e} alt="wooden drawer kitchen storage box modular kitchen wooden drawer" loading="lazy" />
                    <span>WOODEN Wicker Basket </span>
                  </Link>

                   <Link to="/pipe-basket" className="mega-link">
                    <img src={i} alt="pipe basket kitchen stainless steel wire basket cabinet storage" loading="lazy" />
                    <span>Pipe Basket</span>
                  </Link>

                    <Link to="/rolling-shutter" className="mega-link">
                    <img src={h} alt="kitchen rolling shutter cabinet aluminum tambour door system" loading="lazy" />
                    <span>Rolling Shutters</span>
                  </Link>
                    <Link to="/door-closer" className="mega-link">
                    <img src={j} alt="door closer hydraulic automatic door closer heavy duty fitting" loading="lazy" />
                    <span>Door Closer</span>
                  </Link>

                  <Link to="/folding-bracket" className="mega-link">
                    <img src={k} alt="folding bracket wall mounted shelf support heavy duty folding bracket" loading="lazy"  />
                    <span>Folding Bracket</span>
                  </Link>
                  <Link to="/drawer-fitting" className="mega-link">
                    <img src={l} alt="drawer fitting accessories kitchen drawer hardware fittings set" loading="lazy"/> 
                    <span>Drawer Fitting </span>
                  </Link>

                   <Link to="/kitchen-Accessories" className="mega-link">
                    <img src={m} alt="kitchen accessories modular kitchen hardware storage solutions India" loading="lazy" />
                    <span>Kitchen Accessories </span>
                  </Link>

                   <Link to="/door-fitting" className="mega-link">
                    <img src={n} alt="door fitting accessories handles locks hinges door hardware fittings" loading="lazy" />
                    <span>Door Fitting Accessories</span>
                  </Link>

                    <Link to="/aluminium-profile" className="mega-link">
                    <img src={o} alt="door fitting accessories handles locks hinges door hardware fittings" loading="lazy" />
                    <span>Aluminium Profile</span>
                  </Link>
                </div>
              </div>
            </li>
 {/* <a href="/catalogue.pdf">Product Catalogue</a>
     <a href="/price-list.pdf" target="_blank" rel="noopener noreferrer">
  Price List
</a> */}

<div className="slm-doc-dropdown">

  <button className="slm-doc-dropdown-btn">
    Product Catalogue
    <span></span>
  </button>

  <div className="slm-doc-dropdown-menu">

    <a
      href="/catalogue.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Catalogue
    </a>

    <a
      href="/price-list.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      Price List
    </a>

  </div>

</div>

     <li>
              <Link to="/contact">Contact Us</Link>
            </li>




            <li>
              <Link to="/blogs">Blog</Link>
            </li>
<li>
           <Link  aria-label="Call Slimline Hardware on mobile"
            href="tel:+91 9650100908" className="call-btn-nav">
  <FiPhone /> Call Now
</Link></li>
          </ul>

          {/* Hamburger */}
          <div className="hamburger" onClick={() => setMenuOpen(true)}>
            ☰
          </div>
        </div>
      </header>

      {/* ===== MOBILE MENU ===== */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="mobile-header">
          <span className="close-btn" onClick={() => setMenuOpen(false)}>
            ✕
          </span>
        </div>

        <ul>
          <li>
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
          </li>

          <li className="products-item">
            <span
              className="products-link"
              onClick={() => setProductsOpen(!productsOpen)}
            >
              Products ▾
            </span>

            <ul className={`mobile-submenu ${productsOpen ? "open" : ""}`}>
              <li>
                <Link to="/cabinet-hinges" onClick={() => setMenuOpen(false)}>
                  Hinge
                </Link>
              </li>
              <li>
                <Link to="/telescopic-channel" onClick={() => setMenuOpen(false)}>
                  Telescopic Channel
                </Link>
              </li>
              <li>
                <Link to="/corner-solutions" onClick={() => setMenuOpen(false)}>
                  Corner Solutions
                </Link>
              </li>
              <li>
                <Link to="/slim-box" onClick={() => setMenuOpen(false)}>
                  Slim Box
                </Link>
              </li>
              <li>
               <Link to="/pull-out"   onClick={() => setMenuOpen(false)} className="mega-link">
                    
                                      Pullouts
                  </Link>
              </li>
              <li>
                <Link to="/multiuseBasket" onClick={() => setMenuOpen(false)}>
                  Multi Use Basket
                </Link>
              </li>
           <li>
              <Link to="/basket"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                   Basket
                  </Link></li>
<li>
                   <Link to="/pipe-basket"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                  Pipe Basket
                  </Link></li>
                  
           <li> <Link to="/rolling-shutter"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                  Rolling Shutter
                  </Link></li>
    <li> <Link to="/door-closer"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                  Door Closer
                  </Link></li>

 <li><Link to="/door-fitting"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                  Door Fitting
                  </Link></li>
<li><Link to="/drawer-fitting"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                  Drawer Fitting
                  </Link></li>

<li><Link to="/kitchen-Accessories"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                 Kitchen Accessories
                  </Link></li>

<li><Link to="/folding-bracket"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                 Folding Bracket
                  </Link></li>
  <li><Link to="/aluminium-profile"  onClick={() => setMenuOpen(false)} className="mega-link">
                    
                 Aluminium Profile
                  </Link></li>
              
 

            </ul>
          </li>

          <li>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              Contact Us
            </Link>
          </li>


          <div className="slm-doc-dropdown">

  <button className="slm-doc-dropdown-btn">
    Product Catalogue
    <span></span>
  </button>

  <div className="slm-doc-dropdown-menu">

    <a
      href="/catalogue.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Catalogue
    </a>

    <a
      href="/price-list.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      Price List
    </a>

  </div>

</div>

            <li>
              <Link to="/blogs">Blog</Link>
            </li>
          <li><Link href="tel:+91 9650100908"  aria-label="Call Slimline Hardware on mobile" className="call-btn-mobile">
  <FiPhone /> Call Now
</Link> </li>
        </ul>
      </div>

      {menuOpen && <div className="overlay" onClick={() => setMenuOpen(false)} />}
    </>
  );
};

export default Navbar;
